var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('location-card',{attrs:{"location":_vm.location,"selected":_vm.isSelected,"readonly":"","is-map-view":""},on:{"select":_vm.handleSelect,"deselect":_vm.handleDeselect}})
}
var staticRenderFns = []

export { render, staticRenderFns }